import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { Api } from "../api/api";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class AccountService {
  constructor(private http: HttpClient) {}

  get(): Observable<any> {
    return this.http.get(Api.API_URL + "/account");
  }

  save(account: any): Observable<any> {
    return this.http.post(Api.API_URL + "/account", account, {
      observe: "response",
      responseType: "text"
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/account.service.ts